try {
window.$ = window.jQuery = require('jquery');
require('select2/dist/js/select2');
require('jquery-mask-plugin/dist/jquery.mask');
window.Swal = require('sweetalert2/dist/sweetalert2.all.min');
require('bootstrap');
var dt = require( 'datatables.net' )();
} catch (e) {}
